module.exports = __webpack_public_path__ + "static/media/Visa.c3dffc5f.svg";